<template>
  <div>
    <b-card v-if="isCard">
      <vue-apex-charts
        v-if="chartOptions.xaxis.categories.length > 0"
        type="area"
        height="350"
        :options="chartOptions"
        :series="series"
      />
    </b-card>
    <div v-else>
      <vue-apex-charts
        v-if="chartOptions.xaxis.categories.length > 0"
        type="line"
        height="350"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import { BCard } from 'bootstrap-vue'
import moment from 'moment'

export default {
  name: 'AreaChartsSpline',
  components: {
    BCard,
    VueApexCharts,
  },
  props: {
    isCard: {
      type: Boolean,
      default: true,
    },
    seriesData: {
      type: Array,
      required: true,
    },
    labelsData: {
      type: Array,
      required: true,
    },
    titleText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          defaultLocale: 'tr',
          locales: [{
            name: 'tr',
            options: {
              months: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
              shortMonths: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
              days: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
              shortDays: ['Paz', 'Pts', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
              toolbar: {
                download: 'SVG İndir',
                selection: 'Seçim',
                selectionZoom: 'Seçim Yakınlaştırma',
                zoomIn: 'Yakınlaştır',
                zoomOut: 'Uzaklaştır',
                pan: 'Sürükleme',
                reset: 'Sıfırla',
              },
            },
          }],
          height: 350,
          type: 'area',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        fill: {
          type: 'solid',
          opacity: 0.25,
        },
        colors: ['#A4D9A3', '#069DBF', '#F2B33D', '#F23535'],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        title: {
          text: '',
          align: 'left',
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          tickPlacement: 'on',
          type: 'category',
          categories: [],
          title: {
            text: 'Aylar',
          },
          stepSize: 1,
          labels: {
            show: true,
            rotate: -45,
            format: 'MMMM',
            formatter(value) {
              return moment(value).format('MMMM')
            },
            // rotateAlways: true,
            // hideOverlappingLabels: true,
            // showDuplicates: false,
            // trim: false,
          },
        },
        tooltip: {
          x: {
            format: 'MMMM',
          },
        },
        yaxis: {
          title: {
            text: '',
          },
        },
      },
    }
  },
  watch: {
    seriesData: 'setData',
    labelsData: 'setData',
    titleText: 'setData',
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      this.series = this.seriesData
      this.chartOptions.xaxis.categories = this.labelsData
      this.chartOptions.yaxis.title.text = this.titleText
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
